const EventBus = window.VueEventBus
import config from './config'
import component from './component'
import conditionals from './conditionals'
import dates from './dates'
import designer from '../designer/lib'
import dynamic from './dynamic'
import form from './form'
import formatters from './formatters'
import lang from './lang'
import page from './page'
import modals from './dynamic/modals'
import toastAlert from './dynamic/toast'
import settings from './settings'
import utils from './utils'
import validations from './validations'
import cache from './cache'
// import imaging from './imaging'

window.toastAlert = toastAlert

export default {
  EventBus,
  config,
  component,
  conditionals,
  dates,
  designer,
  dynamic,
  form,
  formatters,
  lang,
  page,
  modals,
  toastAlert,
  settings,
  utils,
  validations,
  cache,
  // imaging
}
